export const NODE_ENV = process.env.NODE_ENV;

export const FLAT_DOWNLOAD_URL = process.env.FLAT_DOWNLOAD_URL;

export const FLAT_REGION = process.env.FLAT_REGION;

const LEGAL_BASE_URL = `https://${process.env.FLAT_SERVER_DOMAIN}/legal`;

export const PRIVACY_URL_CN_CN = `${LEGAL_BASE_URL}/privacy`;
export const PRIVACY_URL_CN_EN = `${LEGAL_BASE_URL}/privacy`;

export const PRIVACY_URL_EN_CN = `${LEGAL_BASE_URL}/privacy`;
export const PRIVACY_URL_EN_EN = `${LEGAL_BASE_URL}/privacy`;

export const SERVICE_URL_CN_CN = `${LEGAL_BASE_URL}/service`;
export const SERVICE_URL_CN_EN = `${LEGAL_BASE_URL}/service`;

export const SERVICE_URL_EN_CN = `${LEGAL_BASE_URL}/service`;
export const SERVICE_URL_EN_EN = `${LEGAL_BASE_URL}/service`;

export const FLAT_WEB_BASE_URL = `https://${process.env.FLAT_WEB_DOMAIN}`;
